<template>
  <b-container class="text-center mt-5">
    <b-card class="mx-auto" style="max-width: 400px">
      <h3 class="mb-4">Connexion</h3>

      <!-- Formulaire de demande de magic link -->
      <div v-if="!emailSent">
        <b-form @submit.prevent="requestMagicLink">
          <b-form-group label="Adresse email" label-for="email-input">
            <b-form-input
              id="email-input"
              v-model="email"
              type="email"
              required
              placeholder="votre@email.fr"
            ></b-form-input>
          </b-form-group>

          <b-form-checkbox v-model="rememberMe" class="mb-3">
            Rester connecté (30 jours)
          </b-form-checkbox>

          <b-button
            type="submit"
            variant="primary"
            block
            :disabled="loading || !email"
          >
            <span v-if="loading">
              <b-spinner small></b-spinner> Envoi en cours...
            </span>
            <span v-else>Envoyer le lien de connexion</span>
          </b-button>
        </b-form>

        <b-alert v-if="error" variant="danger" show class="mt-3">
          {{ error }}
        </b-alert>
      </div>

      <!-- Message de confirmation -->
      <div v-else>
        <b-alert variant="success" show>
          <h5>Vérifiez votre boîte mail</h5>
          <p>
            Si l'adresse <strong>{{ email }}</strong> est associée à un compte,
            un lien de connexion vous a été envoyé.
          </p>
          <p>Vérifiez votre boîte de réception (et vos spams).</p>
          <p class="text-muted small">Le lien est valide pendant 1 heure.</p>
        </b-alert>

        <b-button variant="link" @click="resetForm">
          Utiliser une autre adresse email
        </b-button>
      </div>
    </b-card>
  </b-container>
</template>

<script>
import ApiService from "@/service/apiService";

export default {
  name: "Login",
  data() {
    return {
      email: "",
      rememberMe: false,
      loading: false,
      emailSent: false,
      error: null,
    };
  },
  methods: {
    async requestMagicLink() {
      this.loading = true;
      this.error = null;

      try {
        await ApiService.auth.requestLink(this.email, this.rememberMe);
        this.emailSent = true;
      } catch (err) {
        // Erreur réseau uniquement (le backend retourne toujours 200)
        this.error = "Erreur de connexion au serveur. Veuillez réessayer.";
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.email = "";
      this.rememberMe = false;
      this.emailSent = false;
      this.error = null;
    },
  },
};
</script>

<style scoped></style>
